exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, " .card-footer {\r\n    padding: 0;\r\n\r\n} \r\n\r\n.card {\r\n    margin-bottom: 30px;\r\n    height: 600px;\r\n}\r\n\r\n.card-footer button {\r\n    cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/src/app/product-card/product-card.component.css
// module id = ../../../../../src/app/product-card/product-card.component.css
// module chunks = 1